import classNames from 'classnames'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useWidgetState} from '../../../hooks/state-provider'
import {getAlignmentClassName} from '../../../selectors/classes'
import {getComponentConfig} from '../../../selectors/settings'
import {
  getAlignment,
  getDateAndLocationMarginBottom,
  getHorizontalDividerHeight,
  getHorizontalDividerWidth,
  getVerticalDividerHeight,
  getVerticalDividerWidth,
  isDateAndLocationVisible,
  isDateVisible,
  isHorizontalDateAndLocation,
  isLocationVisible,
  isVerticalDividersVisible,
} from '../../../selectors/single-settings'
import {Divider} from '../divider'
import {Date} from './date'
import s from './date-location.scss'
import {DateLocationProps} from './interfaces'
import {Location} from './location'

export const DateLocation = ({event}: DateLocationProps) => {
  const dateAndLocationVisible = useWidgetState(isDateAndLocationVisible)
  const dateVisible = useWidgetState(isDateVisible)
  const locationVisible = useWidgetState(isLocationVisible)
  const dividerVisible = useWidgetState(isVerticalDividersVisible)
  const componentConfig = useWidgetState(getComponentConfig)
  const verticalDividerWidth = getVerticalDividerWidth(componentConfig)
  const verticalDividerHeight = getVerticalDividerHeight(componentConfig)
  const horizontalDividerWidth = getHorizontalDividerWidth(componentConfig)
  const horizontalDividerHeight = getHorizontalDividerHeight(componentConfig)
  const horizontal = isHorizontalDateAndLocation(componentConfig)
  const alignmentClassName = getAlignmentClassName(getAlignment(componentConfig))
  const marginBottom = getDateAndLocationMarginBottom(componentConfig)
  const mobile = useWidgetState(isMobile)

  return dateAndLocationVisible ? (
    <div
      className={classNames(s[alignmentClassName], {
        [s.noDate]: !dateVisible,
        [s.noLocation]: !locationVisible,
        [s.noDivider]: !dividerVisible,
        [s.horizontal]: horizontal,
        [s.mobile]: mobile,
      })}
      data-hook="ev-date-location"
      style={{marginBottom}}
    >
      <Date event={event} className={s.date} dataHook="date" />
      {dividerVisible && (
        <div className={s.verticalDivider}>
          <Divider width={verticalDividerWidth} height={verticalDividerHeight} />
        </div>
      )}
      {dividerVisible && (
        <div className={s.horizontalDivider}>
          <Divider width={horizontalDividerWidth} height={horizontalDividerHeight} />
        </div>
      )}
      <Location event={event} dataHook="location" className={s.location} />
    </div>
  ) : null
}
